import { atom, onConnect } from '@reatom/framework'
import * as DateF from 'date-fns'

export const dateBySecondAtom = atom(new Date(), 'dateBySecondAtom')
onConnect(dateBySecondAtom, (ctx) => {
  const interval = window.setInterval(() => {
    const now = new Date()
    const current = ctx.get(dateBySecondAtom)
    if (DateF.isSameSecond(now, current)) {
      return
    }

    dateBySecondAtom(ctx, new Date())
  }, 500)
  return () => clearInterval(interval)
})

export const dateByMinuteAtom = atom(new Date(), 'dateByMinuteAtom')
onConnect(dateByMinuteAtom, (ctx) => {
  const interval = window.setInterval(() => {
    const now = new Date()
    const current = ctx.get(dateByMinuteAtom)
    if (DateF.isSameMinute(now, current)) {
      return
    }

    dateByMinuteAtom(ctx, new Date())
  }, 30 * 1000)
  return () => clearInterval(interval)
})
